import { makeEnvironmentProviders } from '@angular/core';
import { PCP_LOGGER } from './pcp-logger.interface';
import { PcpLoggerService } from './pcp-logger.service';
import { LOGGING_CONFIG, LoggingConfig } from './logging-config';

/**
 * Provides the PCP logger.
 *
 * ```typescript
 * bootstrapApplication(AppComponent, {
 *     providers: [
 *         provideLogging({ consoleLevel: LogLevel.WARNING }),
 *         provideInsights({ ... }),   // supplies PCP_TELEMETRY_SINK; order vs this call is irrelevant
 *     ],
 * });
 * ```
 *
 * Telemetry is optional. Without a `PCP_TELEMETRY_SINK` the logger writes to the console and sends
 * nothing — which is what component workbenches, unit tests and harness apps want.
 */
export function provideLogging(config?: LoggingConfig) {
    return makeEnvironmentProviders([
        { provide: LOGGING_CONFIG, useValue: config ?? {} },
        { provide: PCP_LOGGER, useClass: PcpLoggerService },
    ]);
}
